import { useContext } from "react";
import { businessSkillsActionTypes } from "../reducer/resume-business-skills-reducer";
import { ResumeContext } from "../resume-context";

function useResumeBusinessSkillsHandlers() {
    const { dispatch } = useContext( ResumeContext );
    return {
        handleAddCategory: ( category ) => {
            dispatch( {
                type: businessSkillsActionTypes.ADD_CATEGORY,
                item: category,
            } );
        },
        handleRemoveCategory: ( category ) => {
            dispatch( {
                type: businessSkillsActionTypes.REMOVE_CATEGORY,
                item: category,
            } );
        },
        handleMoveCategoryUp: ( category ) => {
            dispatch( {
                type: businessSkillsActionTypes.MOVE_CATEGORY_UP,
                item: category,
            } );
        },
        handleMoveCategoryDown: ( category ) => {
            dispatch( {
                type: businessSkillsActionTypes.MOVE_CATEGORY_DOWN,
                item: category,
            } );
        },
        handleAddCompetence: ( competence, parentOrder ) => {
            dispatch( {
                type: businessSkillsActionTypes.ADD_COMPETENCE,
                item: competence,
                parentOrder: parentOrder
            } );
        },
        handleChangeCompetence: ( competence, parentOrder ) => {
            dispatch( {
                type: businessSkillsActionTypes.CHANGE_COMPETENCE,
                item: competence,
                parentOrder: parentOrder
            } );
        },
        handleRemoveCompetence: ( competence, parentOrder ) => {
            dispatch( {
                type: businessSkillsActionTypes.REMOVE_COMPETENCE,
                item: competence,
                parentOrder: parentOrder
            } );
        },
        handleMoveCompetenceUp: ( competence, parentOrder ) => {
            dispatch( {
                type: businessSkillsActionTypes.MOVE_COMPETENCE_UP,
                item: competence,
                parentOrder: parentOrder
            } );
        },
        handleMoveCompetenceDown: ( competence, parentOrder ) => {
            dispatch( {
                type: businessSkillsActionTypes.MOVE_COMPETENCE_DOWN,
                item: competence,
                parentOrder: parentOrder
            } );
        },
    }
}

export default useResumeBusinessSkillsHandlers
